import React, { useEffect, useState} from 'react';
import { NavLink } from "react-router-dom";

import { Button } from "primereact/button";

import questions from './data'

import { useLocation } from "react-router-dom";

import "./question.scss";
import "./question-mobile.scss";

export const Questions = (props) => { 
    const [question, setQuestion] = useState(questions.question1)
    
    const location = useLocation();

    useEffect(()=>{
        props.page(1)
        if(location.pathname.includes('question')){
            props.page(3)
            setQuestion(questions.question2)
        }
    }, [props, location.pathname])
    return (
          <div className="d-flex question-content">
            {/* Left bloc */}
            <div className="d-flex left-block">
              <div className="d-flex large-font question-block">
                <span className={question.title1.class} dangerouslySetInnerHTML={{ __html: question.title1.text}} />
                <span
                  className={question.title2.class}
                  style={{ marginBottom: "5px" }}
                  dangerouslySetInnerHTML={{ __html: question.title2.text}}
                />
                <div className="d-flex large-font">
                  <span className={question.title3.class}  dangerouslySetInnerHTML={{ __html: question.title3.text}} />
                  <span className={question.title4.class}  dangerouslySetInnerHTML={{ __html: question.title4.text}} style={{marginLeft: "7px"}}/>
                </div>
                <div className="d-flex large-font" style={{marginTop:"7px"}}>
                  <span className={question.title5.class}  dangerouslySetInnerHTML={{ __html: question.title5.text}}/>
                  { 
                    question.title6?<span className={question.title6.class}  dangerouslySetInnerHTML={{ __html: question.title6.text}} style={{marginLeft: "7px"}} />: ''
                  }
                </div>
              </div>
  
              <div className="d-flex question-button-bloc">
                <NavLink to={question.url ==='/formulaire'?question.url+'/proposition':question.url} >
                  <Button
                    label="NON"
                    className="d-flex question-button enormous-button p-button-rounded p-button-large p-button-raised ui-button-orange"
                  ></Button>
                </NavLink>
                <NavLink to={question.url ==='/formulaire'?question.url+'/projet':question.url} >
                  <Button
                    label="OUI"
                    className="d-flex question-button enormous-button p-button-rounded p-button-large p-button-raised ui-button"
                  ></Button>
                </NavLink>
              </div>
            </div>
  
            {/* Right bloc */}
            <div className="d-flex right-block">
              <div className="image-block">
                <img src={ require(`../../assets/images/PNG/${question.image}`)} alt="" ></img>
              </div>
            </div>
          </div>
      );
}